import React, { Component } from "react";
import diagram from '../../images/ElectricityLoop.svg';

export default class Login extends Component{
  render(){
    return (
    <div class="container">
      <div className="main-content">
        <h3 className="heading">Power generation</h3>
       
      </div>
    </div>  
    );
  }
}